// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file suppliers/create_supplier.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Supplier } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.CreateSupplierRequest
 */
export class CreateSupplierRequest extends Message<CreateSupplierRequest> {
  /**
   * The supplier to be created
   *
   * @generated from field: com.neulink.pharmacy.Supplier supplier = 1;
   */
  supplier?: Supplier;

  constructor(data?: PartialMessage<CreateSupplierRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.CreateSupplierRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "supplier", kind: "message", T: Supplier },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateSupplierRequest {
    return new CreateSupplierRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateSupplierRequest {
    return new CreateSupplierRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateSupplierRequest {
    return new CreateSupplierRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateSupplierRequest | PlainMessage<CreateSupplierRequest> | undefined, b: CreateSupplierRequest | PlainMessage<CreateSupplierRequest> | undefined): boolean {
    return proto3.util.equals(CreateSupplierRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.CreateSupplierResponse
 */
export class CreateSupplierResponse extends Message<CreateSupplierResponse> {
  /**
   * Unique identifier for the created supplier
   *
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<CreateSupplierResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.CreateSupplierResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateSupplierResponse {
    return new CreateSupplierResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateSupplierResponse {
    return new CreateSupplierResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateSupplierResponse {
    return new CreateSupplierResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateSupplierResponse | PlainMessage<CreateSupplierResponse> | undefined, b: CreateSupplierResponse | PlainMessage<CreateSupplierResponse> | undefined): boolean {
    return proto3.util.equals(CreateSupplierResponse, a, b);
  }
}

